import styled from "styled-components";

const AboutProject = () => {
  return (
    <div>
      <StyledDiv>
        <p>
          <strong>
            Projekat realizovalo Odeljenje za umetničku dokumentaciju Muzeja
            savremene umetnosti, Beograd, u saradnji sa Odeljenjem za razvoj
            Digitalne Narodne biblioteke Srbije.
          </strong>
        </p>
        <p>
          <strong className="grayText">
            Odeljenje za umetničku dokumentaciju MSUB
          </strong>{" "}
          prikuplja, obrađuje, katalogizira i čuva{" "}
          <strong>
            knjige, izložbene kataloge, stručnu periodiku, hemeroteku
          </strong>{" "}
          (članci iz dnevne štampe, nedeljnika i mesečnika) i{" "}
          <strong>fotodokumentaciju</strong> iz oblasti vizuelnih umetnosti, a
          posebno moderne i savremene inostrane, jugoslovenske i srpske
          umetnosti.
        </p>
        <p>
          Zahvaljujući sistematskom prikupljanju građe koje je pratilo
          formiranje zbirki i izložbe MSU, Odeljenje poseduje najkompletniju
          dokumentaciju u regionu o umetnosti i umetnicima sa teritorije bivše
          Jugoslavije. Projekat <strong>čitajte o</strong>... nastao je iz
          potrebe da se ovaj fond učini što pristupačnijim istraživačima,
          studentima, đacima i ljubiteljima umetnosti.
        </p>
        <p>
          <strong>Čitajte o</strong>... predstavlja elektronsku čitaonicu u
          kojoj će se naći najkompletnije bibliografije sa celokupnim tekstovima
          o umetnicima i umetničkim pojavama sa prostora bivše Jugoslavije.
          Elektronska čitaonica će biti proširena foto i video dokumentacijom
          koja se čuva u Odeljenju.
        </p>
        Saznajte sad više o projektu Čitajte o... iz tekstova objavljenih u
        stručnim časopisima i prezentovanih na Medjunarodnim skupovima
        <br></br>
        <br></br> READ ABOUT… Project of Digitization of Art Documentation
        Department, Museum of Contemporary Art, Belgrade, Aleksandra Mirčić and
        Nenad Jeremić Rad je prezentovan na The fourth SEEDI International
        Conference: Digitization of cultural and scientific heritage, June
        12-15, 2008, Belgrade, Serbia, objavljen u elektrinskom časopisuReview
        of the National Center for Digitization Publisher: Faculty of
        Mathematics, Belgrade ISSN: 1820-0109, Issue: 15, Date: 2009.
        <br></br>
        <br></br> Značaj standarda za elektronsku biblioteku na primeru
        elektronske čitaonice “Čitajte o...”, Aleksandra Mirčić, Katarina Jaić
        Rad prezentovan na Međunarodnoj naučnoj konferenciji “Elektronske
        biblioteke” održane od 25-28. septembra 2009 u Beogradu i objavljen u
        zborniku radova sa navedene konferencije.
        <br></br>Autor projekta: Aleksandra Mirčić
        <br></br>Kustos projekta Čitajte o MSUB: Katarina Krstić
        <br></br>Odeljenje za umetničku dokumentaciju: Aleksandra Mirčić,
        Katarina Krstić, Divna Matić, Nedija Kovačević
        <br></br>Programiranje: Nenad Jeremić, Srđan Đukić
        <br></br>Stručni savetnik: Katarina Jaić
        <br></br>Dizajn: Andrej Dolinka
        <br></br>Saradnici: Vuk Jovanović, Milica Vučetić, Neda Radoičić,
        Olivera Nastić, Vlada Todosijević, Danica Đorđević, Jovana Marković
      </StyledDiv>
    </div>
  );
};

const StyledDiv = styled.div`
  margin-top: 2rem;

  @media (max-width: 768px) {
    margin-top: 4rem;
  }
`;

export default AboutProject;
